var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRbacDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.5,
    height: 10.5,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.03 9.47a.751.751 0 01-1.062 1.062L6 6.562l-3.97 3.969A.751.751 0 11.969 9.468L4.938 5.5.968 1.53A.751.751 0 112.032.469L6 4.438 9.97.468a.751.751 0 111.062 1.062L7.062 5.5l3.969 3.97z",
    fill: "#FF2800"
  })));
}
export default SvgRbacDeleteIcon;